module.exports = __webpack_public_path__ + "img/lime_element_2.67eb4cd3.png";